import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "components/SvgIcons";
import { CardIconWrap } from "styles/MainCards.styled";
import { clearIconStatus } from "store/recipesReducer";
import {
  saveRecipeOrCollection,
  deleteOwnCollection,
  deleteOwnRecipe,
  unSaveRecipeOrCollection,
} from "store/recipesReducer/recipesActions";
import { getCardId } from "store/recipesReducer/recipesSelectors";
import { toggleModal, isUserLogin } from "store/loginReducer";

const CardIcon = ({ icon, id, type, action = "save", setSaved, onClick }) => {
  const dispatch = useDispatch();

  const card_id = useSelector(getCardId);

  const isLogin = useSelector(isUserLogin);

  const handleClick = () => {
    if (!isLogin) dispatch(toggleModal(true));
    else if (icon === "save" || icon === "saveslide") {
      dispatch(saveRecipeOrCollection({ type, id, setSaved }));
    } else if (icon === "saved" || icon === "savedslide") {
      dispatch(unSaveRecipeOrCollection({ type, id, setSaved }));
    } else if (type === "recipes" && action === "delete") {
      dispatch(deleteOwnRecipe(id));
    } else if (type === "collections" && action === "delete") {
      dispatch(deleteOwnCollection(id));
    } else {
      onClick();
    }
  };

  useEffect(() => {
    return () => card_id === id && dispatch(clearIconStatus());
  }, []);

  return (
    <>
      <CardIconWrap onClick={(e) => handleClick(e)}>
        <Icon icon={icon} />
      </CardIconWrap>
    </>
  );
};

export default CardIcon;
